import React, { Fragment } from "react";

import { format, isThisYear } from "date-fns";

import CloseIcon from "react-icons/lib/fa/close";

import { Box, Flex, Link, Text } from "src/components";
import { defaultPrevented } from "src/utils";

const Date = ({ date, dateLabel }) => (
  <Fragment>
    {dateLabel ? (
      <Text
        fontWeight="bold"
        textTransform="uppercase"
        color="muted"
        fontSize={2}
      >
        {dateLabel}
      </Text>
    ) : (
      <Flex align="flex-end" justify="center">
        <Text
          fontWeight="light"
          textTransform="uppercase"
          color="grayText"
          fontSize={2}
        >
          {format(date, "MMM")}
        </Text>
        <Text
          numeric={true}
          ml="0.5rem"
          fontWeight="medium"
          fontSize={3}
          color="grayText"
        >
          {format(date, "D")}
        </Text>
      </Flex>
    )}
    {!isThisYear(date) && (
      <Text color="muted" numeric={true} fontWeight="medium">
        {format(date, "YYYY")}
      </Text>
    )}
  </Fragment>
);

class ListItem extends React.Component {
  state = { editing: false };

  handleEditingComplete = ({ messageKey }) => {
    this.setState(() => ({
      editing: false,
      messageKey,
    }));
  };

  handleStartEditing = () => {
    this.setState(() => ({
      editing: true,
    }));
  };

  handleCancelEditing = () => {
    this.setState(() => ({
      editing: false,
    }));
  };

  render() {
    const {
      bg,
      date,
      dateLabel,
      firstItem,
      renderForm,
      renderMenu,
      children,
      t,
    } = this.props;

    const { editing } = this.state;

    const footer =
      editing && renderForm ? (
        <Box px={3} py={3}>
          {renderForm({
            onComplete: this.handleEditingComplete,
            onCancel: this.handleCancelEditing,
          })}
        </Box>
      ) : this.state.messageKey ? (
        <Flex p={2} bg="success" justify="center">
          <Text color="white">{t(this.state.messageKey)}</Text>
        </Flex>
      ) : null;

    return (
      <Box>
        <Flex
          align="stretch"
          borderColor="divider"
          borderWidth={firstItem ? 0 : 1}
          borderTop={true}
          bg={bg}
        >
          <Flex flex={1} align="stretch" style={{ opacity: editing ? 0.5 : 1 }}>
            {date ? (
              <Flex
                p={2}
                borderColor="divider"
                align="center"
                justify="center"
                borderWidth={1}
                borderRight={true}
                width={[100, null, null, 175]}
                flexDirection="column"
              >
                <Date date={date} dateLabel={dateLabel} />
              </Flex>
            ) : null}
            {children}
          </Flex>

          {editing ? (
            <Flex align="center" mx={2}>
              <Link
                to="#"
                onClick={defaultPrevented(this.handleCancelEditing)}
                title="Close transaction form"
                color="blue"
              >
                <CloseIcon size={22} flex={1} />
              </Link>
            </Flex>
          ) : renderMenu ? (
            renderMenu({
              onStartEditing: this.handleStartEditing,
            })
          ) : null}
        </Flex>
        {footer}
      </Box>
    );
  }
}

export default ListItem;



// WEBPACK FOOTER //
// ./src/banking/components/List/ListItem.js